import { Block } from '../../models/block';

class CalendarOverlayLeftMenuLevelBlock extends Block {
    getStyles = () => ({
        ...this.styles,
    });
}

export default CalendarOverlayLeftMenuLevelBlock;
